@if (activeState !== ActiveState.Active) {
    <adapt-toolbar-title>
        <span class="badge me-2"
              [ngClass]="{
                'bg-danger': activeState === ActiveState.Inactive,
                'bg-warning': activeState !== ActiveState.Inactive,
            }"
              [adaptTooltip]="tooltipText">
            <i class="fal"
               [ngClass]="{
                    'fa-exclamation-circle': activeState === ActiveState.Inactive,
                    'fa-timer': activeState !== ActiveState.Inactive,
                }"></i>
            {{ badgeText }}
        </span>
    </adapt-toolbar-title>
}
